import React from "react"
import Modal from "@sections/homePage/Modal"

const ModalPage = () => <Modal className="Modal" overlayClassName="Overlay" />

export default ModalPage
